import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GenericConfirmDialogComponent} from './generic-confirm-dialog/generic-confirm-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {BrowserModule} from '@angular/platform-browser';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
	declarations: [
		GenericConfirmDialogComponent,
	],
	imports: [
		MatDialogModule,
		MatButtonModule,
		CommonModule,
		BrowserModule,
	],
	exports: [
		GenericConfirmDialogComponent
	]
})
export class DialogModule {
}
